import { indigo, orange } from '@material-ui/core/colors';
import { ThemeOptions } from '@material-ui/core/styles/createMuiTheme';
import { CSSProperties } from 'react';

declare module '@material-ui/core/styles/createMuiTheme' {
	// tslint:disable: interface-name (既存インタフェースの拡張)
	/**
	 * テーマ拡張用プロパティ群
	 */
	interface Extends {
		/**
		 * react-table用
		 */
		MuiReactTable: Partial<Record<'root', CSSProperties>>;
	}

	interface ThemeOptions {
		extends?: Extends;
	}

	interface Theme {
		extends: Extends;
	}
	// tslint:enable: interface-name
}

const theme: ThemeOptions = {
	extends: {
		MuiReactTable: {
			root: {
				fontFamily: '"ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif',
				fontSize: '0.875rem',
			},
		},
	},
	overrides: {
		MuiButton: {
			root: {
				fontFamily: '"ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif',
			},
		},
		MuiMenuItem: {
			root: {
				fontFamily: '"ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif',
				fontSize: '0.875rem',
			},
		},
		MuiToolbar: {
			regular: {
				'@media (min-width: 600px)': {
					minHeight: '48px',
				},
			},
		},
	},
	palette: {
		background: {
			default: indigo[50],
			paper: '#fff',
		},
		primary: indigo,
		secondary: orange,
	},
	typography: {
		fontFamily:
			'"Yu Gothic Medium", "游ゴシック Medium", YuGothic, "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", Roboto, sans-serif',
		h6: {
			fontFamily: '"ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif',
		},
	},
};

export default theme;



// WEBPACK FOOTER //
// ./src/theme.ts